module.exports = __webpack_public_path__ + "static/media/cross-3.a78874e2.svg";